import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ResumeData, SelectedCV } from '../../models/virtual-interview-model';

@Component({
  selector: 'app-upload-resume',
  templateUrl: './upload-resume.component.html',
  styleUrls: ['./upload-resume.component.css'],
})
export class UploadResumeComponent {
  @Output() next = new EventEmitter<ResumeData>();
  @Output() previous = new EventEmitter<void>();

  selectedResumeType: string = 'current';
  IsUploadCv = false;
  loading = false;
  uploadedCV: File | null = null;

  showCVSelectionPopup: boolean = false;
  selectedCV: SelectedCV | null = null;

  constructor(private fb: FormBuilder) {}

  onCVDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.uploadedCV = files[0];
    }
  }

  onCVSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadedCV = input.files[0];
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  openCVSelectionPopup(): void {
    this.showCVSelectionPopup = true;
  }

  closeCVSelectionPopup(): void {
    this.showCVSelectionPopup = false;
  }

  onCVSelectedFromPopup(cv: SelectedCV): void {
    this.selectedCV = cv;
  }

  canProceed(): boolean {
    if (!this.selectedResumeType) {
      return false;
    }

    if (this.selectedResumeType === 'upload') {
      return !!this.uploadedCV;
    }

    if (this.selectedResumeType === 'current') {
      return !!this.selectedCV;
    }

    return false;
  }

  onNext(): void {
    if (!this.canProceed()) {
      if (this.selectedResumeType === 'upload' && !this.uploadedCV) {
        alert('Please upload your CV file');
      } else if (this.selectedResumeType === 'current' && !this.selectedCV) {
        alert('Please select a CV from your existing CVs');
      }
      return;
    }

    const data: ResumeData = {
      type: this.selectedResumeType as 'upload' | 'current',
      uploadedCV: this.selectedResumeType === 'upload' ? this.uploadedCV : null,
      selectedCV: this.selectedResumeType === 'current' ? this.selectedCV : null
    };

    console.log('Resume data:', {
      type: data.type,
      fileName: data.uploadedCV?.name,
      cvPath: data.selectedCV?.imagePath
    });

    this.next.emit(data);
  }

  onPrevious(): void {
    this.previous.emit();
  }

  removeCV(): void {
    this.uploadedCV = null;
  }

  removeSelectedCV(): void {
    this.selectedCV = null;
  }
}